import Flickity from 'flickity'
import 'flickity-fade'
import 'flickity-as-nav-for'
import 'flickity-imagesloaded'
import 'flickity/dist/flickity.css'
import 'flickity-fade/flickity-fade.css'

export const ARROW_SHAPE = 'M97.8098193,45.3819169 L7.45269818,45.3819169 L28.2350794,20.4395157 C29.0868163,19.4255969 29.0868163,17.7743578 28.2350794,16.7604391 C27.3833425,15.7465203 25.996228,15.7465203 25.1444911,16.7604391 L0.638802701,46.1640828 C-0.212934234,47.1780016 -0.212934234,48.8292407 0.638802701,49.8431594 L25.1444911,79.2178341 C25.5825272,79.739278 26.1422401,80 26.7019529,80 C27.2616658,80 27.8213786,79.739278 28.2350794,79.2468032 C29.0868163,78.2328845 29.0868163,76.5816454 28.2350794,75.5677266 L7.45269818,50.5963562 L97.8098193,50.5963562 C99.0265864,50.5963562 100,49.4375919 100,47.9891366 C100,46.5406812 99.002251,45.3819169 97.8098193,45.3819169 Z'

export const SIMPLE_ARROW_SHAPE = 'M13.9380531,45.9092452 L52.8053097,6.93674324 C54.3982301,5.35249519 54.3982301,2.77243408 52.8053097,1.18818604 C51.2123894,-0.396062012 48.6182048,-0.396062012 47.0252845,1.18818604 L1.19469027,47.1313794 C-0.398230088,48.7156275 -0.398230088,51.2956886 1.19469027,52.8799366 L47.0252845,98.7778658 C47.8445006,99.5926219 48.8912769,100 49.9380531,100 C50.9848293,100 52.0316056,99.5926219 52.8053097,98.82313 C54.3982301,97.238882 54.3982301,94.6588209 52.8053097,93.0745728 L13.9380531,54.0568066 C12.2629817,52.2670721 11.425446,50.9148033 11.425446,50 C11.425446,49.0851967 12.2629817,47.7216118 13.9380531,45.9092452 Z'

const SLIDER_DEFAULTS = {
  autoPlay: 6000,
  adaptiveHeight: true,
  pauseAutoPlayOnHover: false,
  cellAlign: 'left',
  groupCells: '100%',
  wrapAround: true,
  arrowShape: ARROW_SHAPE,
  imagesLoaded: true,
  draggable: '>1'
}

Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize')
}

Flickity.createMethods.push('_createResizeClass')

const resize = Flickity.prototype.resize

Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize')
  resize.call(this)
  this.element.classList.add('flickity-resize')
}

export function setupSlider($el, _opts) {
  const opts = Object.assign({}, SLIDER_DEFAULTS, _opts)

  if (opts.prevNextButtons !== false) {
    $el.classList.add('has-buttons')
  }

  if ($el.children.length) {
    $el.classList.add('is-single-slide')
  }

  $el.classList.add('is-init')
  $el.offsetHeight

  const slider = new Flickity($el, opts)

  slider.on('resize', function () {
    const isSingleSlide = this.slides.length < 2
    const hasPrevNextButtons = this.options.prevNextButtons

    this.element.classList.toggle('is-single-slide', isSingleSlide)
    this.element.classList.toggle('has-buttons', hasPrevNextButtons)
  })

  setTimeout(slider.resize.bind(slider), 250)

  return slider
}
